  (function() {
    window.CartPage = window.CartPage || new function() {
    //runs once per page load
    var self = this;
    
    // The whole cart section is replaced on every update, which destroys the control the user
    // just activated; remember it so focus can be put back on its replacement.
    function describeFocusedControl() {
      var el = document.activeElement;
      if (!el || !el.closest) return null;
      var item = el.closest('#cart .item');
      if (!item) return null;
      var selector = null;
      if (el.classList.contains('plus')) selector = '.quantity-button.plus';
      else if (el.classList.contains('minus')) selector = '.quantity-button.minus';
      else if (el.classList.contains('remove')) selector = '.remove';
      else if (el.matches('input[type=number]')) selector = 'input[type=number]';
      if (!selector) return null;
      // Shopify regenerates each line's data-key on every update, so the line is identified
      // by its position instead.
      var items = Array.prototype.slice.call(document.querySelectorAll('#cart .item'));
      return { index: items.indexOf(item), selector: selector };
    }

    function restoreFocusedControl(info) {
      if (!info || info.index < 0) return;
      var item = document.querySelectorAll('#cart .item')[info.index];
      var target = item && item.querySelector(info.selector);
      if (!target) {
        // The line was removed entirely; fall back to the cart heading.
        target = document.querySelector('#cart h1') || document.querySelector('#cart .empty .title');
        if (!target) return;
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      }
      target.focus();
    }

    self.updateCart = function() {
      var focusInfo = self.pendingFocus || describeFocusedControl();
      self.pendingFocus = null;
      $s.showLoadingOverlay();
      $s.getJson({url: '/?sections=cart_content', success: function(data){
        var section = document.querySelector('.cart-content');
        section.outerHTML = data['cart_content'];
        $s.globalEval(section);
        $s.hideLoadingOverlay();
        restoreFocusedControl(focusInfo);
      }});
    }

    self.updateItemsQuantity = function(items, quantity){
      // Captured here, while the activated control still holds focus — the loading overlay
      // shown further down drops focus back to the body.
      self.pendingFocus = describeFocusedControl();
      var data = {updates: {}}
      items.forEach(function(item) {
        data.updates[item.dataset.key] = quantity;
      });
      postUpdate(data);
    }

    function postUpdate(data) {
      $s.showLoadingOverlay();
      $s.post({
        type: 'POST',
        url: '/cart/update.js',
        data: data,
        dataType: 'json',
        success: function() {
          //overlay reopened by updateCart()
          //$s.hideLoadingOverlay();
          self.updateCart();
        },
        error: $s.addToCartFail
      });
    }
  
  };
  //runs every time #cart div is replaced
  var cart = document.getElementById('cart');
  var itemsCount = 0;
  cart.querySelectorAll('.quantity-box input[type=number]').forEach(function(item){
    itemsCount += item.value/1;
  });
  var cartCountElement = document.querySelector('header .cart-count');
  if(cartCountElement) {
    cartCountElement.innerHTML = itemsCount>0?itemsCount:'';
  }

  cart.querySelectorAll('.remove').forEach(function(item) {
    item.addEventListener('click', function(e){
      e.preventDefault();
      var items = $s.getItemsToUpdate(this.closest('.item'), 0);
      CartPage.updateItemsQuantity(items, 0);
    });
  });

  cart.querySelectorAll('input[type=number]').forEach(function(item) {
    item.addEventListener('change', function(e){
      var items = $s.getItemsToUpdate(this.closest('.item'), this.value);
      CartPage.updateItemsQuantity(items, this.value);
    });
  });

  if (window.themeSettings.allowNote) {      
  var checkInstructions = document.getElementById('chk-instructions');
  if (checkInstructions) {
    var checkInstructionsChange = function() {
      var note = document.getElementById('instructions-note');
      if (checkInstructions.checked) {
        note.style.display = 'block';
      } else {
        note.style.display = 'none';
        var textarea = note.querySelector('textarea');
        if (textarea.value != '') {
          textarea.value = '';
          $s.dispatchEvent(textarea, 'change');
        }
      }
    }
    checkInstructions.labels[0].addEventListener('keypress', function(event) {
      if (event.keyCode==13) {
        checkInstructions.click();
      }
    });
    checkInstructions.addEventListener('click', checkInstructionsChange);
    checkInstructionsChange();
  }
  }

  $s.validateBundlesInHTML(document.querySelectorAll('#cart .item'));
  })();